import { IconArrowDown } from './IconArrowDown'

export const IconArrowRight = () => (
  <div style={{ transform: 'rotateZ(-90deg)' }}>
    <IconArrowDown />
  </div>
)
